import React from "react";
import { Input } from "../../Input";

export default class Hex extends React.Component{
    constructor(props){
        super(props);
        this.state={
            hexInput: "",
            bintohex: "",
            dectohex: ""
        }
    }
    handleInput=(e)=>{
        const target = e.target;
        const value = target.value;
        const name = target.name;
        let nv = "";
        nv = this.props.caracterFilter(value,name);
        this.setState({hexInput: nv.toUpperCase()})
    }
    // Quand il recoit une valeur exterieure, il la garde comme siennne
    // setHexInput=(type)=>{
    //     if(type==="dec"){
    //         this.setState({hexInput: this.dectohex})
    //     }
    //     else{
    //         this.setState({hexInput: this.bintohex})
    //     }
        
    // }
    componentDidUpdate(prevProps,prevState){
        if(prevState.hexInput!==this.state.hexInput){
            this.props.setFrom("hextobin",this.props.hexToBin(this.state.hexInput));
            this.props.setFrom("hextodec",this.props.hexToDec(this.state.hexInput));
        }

    }
    componentWillReceiveProps(nextProps){
        if(nextProps.touched.decInput){
            if(nextProps.dectohex===""){
                this.setState({hexInput: ""})
                return
            }
            this.setState({hexInput: nextProps.dectohex})
        }
        else if(nextProps.touched.binInput){
            if(nextProps.bintohex===""){
                this.setState({hexInput: ""})
                return
            }
            this.setState({hexInput: nextProps.bintohex})
        }
    }
    render(){

    return(
        
        <Input
            textColor="green"
            className="form-control" 
            name="hexInput" 
            type="text" 
            value={this.state.hexInput} 
            onChange={this.handleInput} 
            onBlur={this.props.onBlur("hexInput")} 
            onFocus={this.props.onFocus("hexInput")} />
    );
    }
    
} 